import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { ArrowRight, Shield } from 'lucide-react';

const CTASectionB = () => {
  return (
    <section className="py-8">
      <div className="relative overflow-hidden rounded-2xl bg-primary">
        {/* Background decoration */}
        <div className="absolute inset-0 opacity-20">
          <div className="absolute top-0 right-0 w-1/2 h-1/2 bg-gradient-radial from-white/20 to-transparent rounded-full blur-3xl" />
          <div className="absolute bottom-0 left-0 w-1/3 h-1/3 bg-gradient-radial from-white/10 to-transparent rounded-full blur-2xl" />
        </div>
        
        {/* Content */}
        <div className="relative text-center px-6 py-12 lg:py-16">
          <h2 className="text-2xl lg:text-3xl font-bold text-primary-foreground mb-3">
            You plan for your finances. Plan for your safety.
          </h2>
          <p className="text-lg text-primary-foreground/90 max-w-xl mx-auto mb-6">
            Waiting until an accident happens is too late. Create your account, scan your living room, and sleep better tonight.
          </p>
          
          {/* Trust indicator */}
          <div className="flex items-center justify-center gap-2 mb-6 text-primary-foreground/80">
            <Shield className="w-4 h-4" />
            <span className="text-sm">7-Day Free Trial • Cancel Anytime</span>
          </div>
          
          {/* Action button */}
          <Button 
            size="lg" 
            variant="secondary"
            className="bg-white text-primary hover:bg-white/95 shadow-lg font-semibold group"
            asChild
          >
            <Link to="/pricing" className="flex items-center gap-2">
              Get ThriveMax Today
              <ArrowRight className="w-4 h-4 group-hover:translate-x-0.5 transition-transform" />
            </Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CTASectionB;
